import { axiosClient } from '../../../shared/api';

export const listUsers = async () => {
  const response = await axiosClient.get('/users');
  return response.data;
};

export const createUser = async (userData) => {
  const response = await axiosClient.post('/users', userData);
  return response.data;
};

export const updateUser = async (userId, updatedData) => {
  const response = await axiosClient.put(`/users/${userId}`, updatedData);
  return response.data;
};

export const getUser = async (userId) => {
  const response = await axiosClient.get(`/users/${userId}`);
  return response.data;
};

export const activateUser = async (userId) => {
  const response = await axiosClient.patch(`/users/${userId}`, { action: 'activate' });
  return response.data;
};

export const deactivateUser = async (userId) => {
  const response = await axiosClient.patch(`/users/${userId}`, { action: 'deactivate' });
  return response.data;
};
